import { cn } from '../../utils'

interface AtMapPinProps {
  selected?: boolean
  title?: string
}

export const AtMapPin = ({ selected, title }: AtMapPinProps) => (
  <svg
    aria-label={title || 'Map pin'}
    className={cn(
      'transition-colors motion-reduce:transition-none',
      selected ? 'text-neutrals-white' : 'text-transparent hover:text-neutrals-400'
    )}
    width="25"
    height="40"
    viewBox="0 0 25 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4896_2980)">
      <path
        d="M12.604 38.2291C11.979 36.9791 10.9373 35.2083 9.479 32.6041C7.70817 29.5833 5.4165 25.8333 3.74984 22.2916C1.77067 18.1249 0.729004 14.9999 0.729004 12.7083C0.729004 9.47908 1.979 6.56242 4.1665 4.27075C6.45817 1.97909 9.37484 0.833252 12.7082 0.833252C16.0415 0.833252 18.854 2.08325 21.2498 4.27075C23.5415 6.56242 24.6873 9.47908 24.6873 12.7083C24.6873 18.4374 19.2707 27.2916 15.6248 33.2291C14.1665 35.4166 13.229 37.0833 12.604 38.2291Z"
        fill="#353B56"
        stroke="#D5D8DB"
        stroke-width="1.04167"
      />
      <circle cx="12.5" cy="12.5" r="6.5" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_4896_2980">
        <rect width="25" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
